// logger.js - Logger Configuration
/* eslint-disable */
import jsLogger from 'js-logger';
import { logWinFileChange } from './shared/api/url-helper';
import { getCurrentDate } from './components/project-info/ProjectInfo';
import { get_curr_file_name, set_curr_file_name } from './components/userData';

const logCollection = [];

jsLogger.useDefaults();

// to log everyThing
jsLogger.setHandler((messages, context) => {
  logCollection.push({
    timestamp: getCurrentDate('sec'), // new Date().toISOString(),
    message: messages[0],
    // level: context.level.name,
    // component: messages[1] || 'General'
  });
});

// log only the message
// jsLogger.setHandler((messages) => {
//   logCollection.push({
//     message: messages[0]
//   });
// });

export const getLogs = () => logCollection;

export const clearLogs = () => {

  const logs = getLogs();
  // comm
  const getUserEmail = sessionStorage.getItem('user_email');
  const getUserType = getUserEmail?.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
  const changeJSON = {
    'fileName': `${get_curr_file_name()}`,
    'userEmail': getUserEmail,
    'userType': getUserType,
    'changeLog': { [getCurrentDate()]: logs },
    'env' : process.env.REACT_APP_ENV
    // 'changeLog' : {[getCurrentDate()] : logFileDataChange(FlowData)}  //old one
  };

  // axios({
  //   method: 'post',
  //   url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/logWinFileChange',
  //   headers: {},
  //   data: JSON.stringify(changeJSON)
  // })
  logWinFileChange(changeJSON)
    .then((res) => {
      console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });

  // To-do : Make a api call and store the logs into S3 bucket then clear the logs data
  const fname = get_curr_file_name();

  while (logCollection.length > 0) {
    logCollection.pop();
  }
  set_curr_file_name('');
};

export const JustclearLog = () => {

  while (logCollection.length > 0) {
    logCollection.pop();
  }
  set_curr_file_name('');
};

export default jsLogger;

/**
 * How to use in the componement
In your components
import jsLogger from './logger';

jsLogger.info('This is a message');
jsLogger.info('Another message');

To get logs
const logs = getLogs();
Will output:
[
  { message: 'This is a message' },
  { message: 'Another message' }
]
 */
